import { AxiosError } from 'axios';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { App } from 'antd';

import { axiosClient } from '@/lib/axios';
import { queryClient } from '@/lib/react-query';

type Payload = {
  companyID: number;
  meetingID: number;
  meetingPointID: number;
};

export const deleteMeetingPoint = async ({
  companyID,
  meetingID,
  meetingPointID,
}: Payload): Promise<{ data: { status: string } }> => {
  const { data } = await axiosClient.delete<{ data: { status: string } }>(
    `/companies/${companyID}/meetings/${meetingID}/meeting-points/${meetingPointID}`,
  );

  return data;
};
type UseDeleteMeetingPointOptions = {
  config?: Partial<UseMutationOptions<{ data: { status: string } }, AxiosError<{ status: string }>, Payload>>;
  postSuccess?: () => void;
};

export const useDeleteMeetingPoint = ({ config, postSuccess }: UseDeleteMeetingPointOptions) => {
  const { notification: toaster } = App.useApp();
  return useMutation({
    onError: (error) => {
      toaster.error({
        message: 'Something Went Wrong',
        description: error.message,
      });
    },
    onSuccess: async (_, params) => {
      await queryClient.invalidateQueries({
        queryKey: ['meetings'],
      });
      await queryClient.invalidateQueries({
        queryKey: ['meeting-details', params.companyID],
      });
      await queryClient.invalidateQueries({
        queryKey: ['meeting-points', params.companyID],
      });
      toaster.success({
        message: 'Deleted Successfully',
        description: 'Meeting Point Deleted Successfully',
      });
      postSuccess?.();
    },
    ...config,
    mutationFn: deleteMeetingPoint,
  });
};
